module.exports = __webpack_public_path__ + "static/l-slide01-fab1af2998f64ba456260c50ec1956c7.png";